import { useEffect, useState } from 'react';
import { Description, Drawer, type OverlayTriggerState } from '@heroui/react';
import { FilterPopoverFooter } from '../../../components/ui/filter-popover-footer';
import {
  drawerBodyClassName,
  drawerFooterClassName,
  sideDrawerDialogClassName,
} from '../../../components/ui/side-drawer-classes';
import {
  countActiveUsageHistoryFilters,
  defaultUsageHistoryFilters,
  hasActiveUsageHistoryFilters,
  type UsageHistoryFilters,
} from '../utils/usage-history';
import { UsageHistoryFiltersForm } from './usage-history-filters-form';

interface UsageHistoryFiltersDrawerProps {
  state: OverlayTriggerState;
  appliedFilters: UsageHistoryFilters;
  onApply: (filters: UsageHistoryFilters) => void;
}

export function UsageHistoryFiltersDrawer({
  state,
  appliedFilters,
  onApply,
}: UsageHistoryFiltersDrawerProps) {
  const [draftFilters, setDraftFilters] = useState(appliedFilters);

  const draftActive = hasActiveUsageHistoryFilters(draftFilters);
  const appliedActive = hasActiveUsageHistoryFilters(appliedFilters);

  useEffect(() => {
    if (state.isOpen) {
      setDraftFilters(appliedFilters);
    }
  }, [state.isOpen, appliedFilters]);

  const handleReset = () => {
    setDraftFilters(defaultUsageHistoryFilters);
    onApply(defaultUsageHistoryFilters);
    state.close();
  };

  const handleApply = () => {
    onApply(draftFilters);
    state.close();
  };

  return (
    <Drawer state={state}>
      <Drawer.Backdrop isDismissable>
        <Drawer.Content placement="right">
          <Drawer.Dialog className={sideDrawerDialogClassName}>
            <Drawer.Header>
              <Drawer.Heading>Filtros do Histórico</Drawer.Heading>
              <Drawer.CloseTrigger />
            </Drawer.Header>

            <Drawer.Body className={drawerBodyClassName}>
              <Description>Refine a busca por período, código, status e tipo de uso.</Description>
              <UsageHistoryFiltersForm filters={draftFilters} onChange={setDraftFilters} />
            </Drawer.Body>

            <Drawer.Footer className={drawerFooterClassName}>
              <FilterPopoverFooter
                showReset={appliedActive || draftActive}
                onReset={handleReset}
                onApply={handleApply}
              />
            </Drawer.Footer>
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </Drawer>
  );
}

export function useUsageHistoryFiltersCount(filters: UsageHistoryFilters): number {
  return countActiveUsageHistoryFilters(filters);
}
